import { API_BASE_URL } from "../../constant/constant";
// AvatarSelection.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  PageContainer,
  Title,
  Description,
  AvatarContainer,
  AvatarImage,
  NextButton,
  CarouselContainer,
  AvatarDiv,
} from "./style";
import { AVATARS } from "../../Components/Constants/Constants";
import { useTranslation } from "react-i18next";

const AvatarSelection = () => {
  const [selectedAvatar, setSelectedAvatar] = useState(1);
  const navigate = useNavigate();
  const carouselRef = useRef();
  const { t } = useTranslation();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  useEffect(() => {
    const fetchAvatar = async () => {
      try {
        const userId = localStorage.getItem("id");
        const response = await fetch(
          `${API_BASE_URL}/api/auth/get-avatar?user_id=${userId}`,
        );
        const data = await response.json();

        if (data.responseCode === 200 && data.avatar?.imageId) {
          const avatarIndex = AVATARS.findIndex(
            (avatar) => avatar.imageId === data.avatar.imageId,
          );
          const finalIndex = avatarIndex !== -1 ? avatarIndex : 1;
          setSelectedAvatar(finalIndex);
        }
      } catch (error) {
        console.error("Error fetching avatar:", error);
        setSelectedAvatar(1);
      }
    };

    fetchAvatar();
  }, []);

  const handleAvatarClick = (index) => {
    setSelectedAvatar(index);
  };

  const handleNextClick = () => {
    const selectedImageId = AVATARS[selectedAvatar].imageId;
    navigate("/avatar-info", { state: { imageId: selectedImageId } });
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  console.log(AVATARS);

  return (
    <PageContainer>
      <AvatarDiv>
        <Title>{t("steps.choose")}</Title>
        <Description>
          Kies je AI-assistent en zie hoe hij/zij wonderen voor je verricht!
        </Description>

        <CarouselContainer>
          <Carousel
            ref={carouselRef} // Attach the ref here
            responsive={responsive}
            arrows
            draggable
            infinite={false}
            centerMode={true}
            keyBoardControl={true}
            goToSlide={2}
            customTransition="transform 300ms ease-in-out"
            // containerClass="carousel-with-dots"
            // dotListClass="carousel-dots"
            // itemClass="carousel-item "
          >
            {AVATARS?.map((avatar, index) => (
              <AvatarContainer
                key={index}
                onClick={() => handleAvatarClick(index)}
                isSelected={selectedAvatar === index}
              >
                <AvatarImage src={avatar.src} alt={avatar.alt} />
              </AvatarContainer>
            ))}
          </Carousel>
        </CarouselContainer>
        <div style={{ display: "flex" }}>
          <NextButton
            style={{ background: "none", color: "#313133" }}
            onClick={handleBackClick}
          >
            Terug
          </NextButton>
          <NextButton onClick={handleNextClick}>Volgende</NextButton>
        </div>
      </AvatarDiv>
    </PageContainer>
  );
};

export default AvatarSelection;
